/** biome-ignore-all lint/complexity/noStaticOnlyClass: No other way to do it*/

import {
	AccordionUmbBlockElementModelContentType,
	AlertUmbBlockElementModelContentType,
	ButtonUmbBlockElementModelContentType,
	CarouselUmbBlockElementModelContentType,
	CollapsibleUmbBlockElementModelContentType,
	ContactCardUmbBlockElementModelContentType,
	ContentFeedUmbBlockElementModelContentType,
	CustomizableLinkUmbBlockPartialElementModelContentType,
	DividerUmbBlockElementModelContentType,
	DrawerButtonUmbBlockElementModelContentType,
	DropdownUmbBlockElementModelContentType,
	EmbedUmbBlockElementModelContentType,
	FormUmbBlockElementModelContentType,
	FourColumnUmbBlockGridElementModelContentType,
	GalleryUmbBlockElementModelContentType,
	GoogleTranslateLanguageSelectorUmbBlockElementModelContentType,
	HeroUmbBlockElementModelContentType,
	IconUmbBlockElementModelContentType,
	ImageAndTextUmbBlockElementModelContentType,
	ImageUmbBlockElementModelContentType,
	KeyFigureUmbBlockElementModelContentType,
	LanguageSelectorUmbBlockElementModelContentType,
	LinkListUmbBlockElementModelContentType,
	LoginLogoutUmbBlockElementModelContentType,
	LogoUmbBlockElementModelContentType,
	MegaMenuUmbBlockElementModelContentType,
	NestedLayoutUmbBlockElementModelContentType,
	OneColumnUmbBlockGridElementModelContentType,
	OneThreeColumnUmbBlockGridElementModelContentType,
	OneTwoOneColumnUmbBlockGridElementModelContentType,
	OneTwoUmbBlockGridElementModelContentType,
	SearchBarUmbBlockElementModelContentType,
	SearchFieldUmbBlockElementModelContentType,
	SpacerUmbBlockElementModelContentType,
	SubmenuUmbBlockElementModelContentType,
	TableOfContentsUmbBlockElementModelContentType,
	TabsUmbBlockElementModelContentType,
	TeaserUmbBlockElementModelContentType,
	TestimonialUmbBlockElementModelContentType,
	TextUmbBlockElementModelContentType,
	ThreeColumnUmbBlockGridElementModelContentType,
	ThreeOneColumnUmbBlockGridElementModelContentType,
	TwoColumnUmbBlockGridElementModelContentType,
	TwoOneColumnUmbBlockGridElementModelContentType,
	VideoUmbBlockElementModelContentType,
} from "#/_generated/umbraco/delivery-api/models";

export class ElementTypes {
	static Accordion = AccordionUmbBlockElementModelContentType.accordionUmbBlock;
	static Alert = AlertUmbBlockElementModelContentType.alertUmbBlock;
	static Button = ButtonUmbBlockElementModelContentType.buttonUmbBlock;
	static Carousel = CarouselUmbBlockElementModelContentType.carouselUmbBlock;
	static Collapsible =
		CollapsibleUmbBlockElementModelContentType.collapsibleUmbBlock;
	static ContactCard =
		ContactCardUmbBlockElementModelContentType.contactCardUmbBlock;
	static ContentFeed =
		ContentFeedUmbBlockElementModelContentType.contentFeedUmbBlock;
	static Divider = DividerUmbBlockElementModelContentType.dividerUmbBlock;
	static DrawerButton =
		DrawerButtonUmbBlockElementModelContentType.drawerButtonUmbBlock;
	static Dropdown = DropdownUmbBlockElementModelContentType.dropdownUmbBlock;
	static Embed = EmbedUmbBlockElementModelContentType.embedUmbBlock;
	static Form = FormUmbBlockElementModelContentType.formUmbBlock;
	static Gallery = GalleryUmbBlockElementModelContentType.galleryUmbBlock;
	static Hero = HeroUmbBlockElementModelContentType.heroUmbBlock;
	static Icon = IconUmbBlockElementModelContentType.iconUmbBlock;
	static ImageAndText =
		ImageAndTextUmbBlockElementModelContentType.imageAndTextUmbBlock;
	static Image = ImageUmbBlockElementModelContentType.imageUmbBlock;
	static KeyFigure = KeyFigureUmbBlockElementModelContentType.keyFigureUmbBlock;
	static LanguageSelector =
		LanguageSelectorUmbBlockElementModelContentType.languageSelectorUmbBlock;
	static GoogleTranslateLanguageSelector =
		GoogleTranslateLanguageSelectorUmbBlockElementModelContentType.googleTranslateLanguageSelectorUmbBlock;
	static LinkList = LinkListUmbBlockElementModelContentType.linkListUmbBlock;
	static LoginLogout =
		LoginLogoutUmbBlockElementModelContentType.loginLogoutUmbBlock;
	static Logo = LogoUmbBlockElementModelContentType.logoUmbBlock;
	static MegaMenu = MegaMenuUmbBlockElementModelContentType.megaMenuUmbBlock;
	static NestedLayout =
		NestedLayoutUmbBlockElementModelContentType.nestedLayoutUmbBlock;
	static SearchBar = SearchBarUmbBlockElementModelContentType.searchBarUmbBlock;
	static SearchField =
		SearchFieldUmbBlockElementModelContentType.searchFieldUmbBlock;
	static Spacer = SpacerUmbBlockElementModelContentType.spacerUmbBlock;
	static Submenu = SubmenuUmbBlockElementModelContentType.submenuUmbBlock;
	static TableOfContents =
		TableOfContentsUmbBlockElementModelContentType.tableOfContentsUmbBlock;
	static Tabs = TabsUmbBlockElementModelContentType.tabsUmbBlock;
	static Teaser = TeaserUmbBlockElementModelContentType.teaserUmbBlock;
	static Testimonial =
		TestimonialUmbBlockElementModelContentType.testimonialUmbBlock;
	static Text = TextUmbBlockElementModelContentType.textUmbBlock;
	static Video = VideoUmbBlockElementModelContentType.videoUmbBlock;
	static OneColumnBlockGrid =
		OneColumnUmbBlockGridElementModelContentType.oneColumnUmbBlockGrid;
	static OneTwoColumnBlockGrid =
		OneTwoUmbBlockGridElementModelContentType.oneTwoUmbBlockGrid;
	static OneTwoOneColumnBlockGrid =
		OneTwoOneColumnUmbBlockGridElementModelContentType.oneTwoOneColumnUmbBlockGrid;
	static OneThreeColumnBlockGrid =
		OneThreeColumnUmbBlockGridElementModelContentType.oneThreeColumnUmbBlockGrid;
	static TwoColumnBlockGrid =
		TwoColumnUmbBlockGridElementModelContentType.twoColumnUmbBlockGrid;
	static TwoOneColumnBlockGrid =
		TwoOneColumnUmbBlockGridElementModelContentType.twoOneColumnUmbBlockGrid;
	static ThreeColumnBlockGrid =
		ThreeColumnUmbBlockGridElementModelContentType.threeColumnUmbBlockGrid;

	static ThreeOneColumnBlockGrid =
		ThreeOneColumnUmbBlockGridElementModelContentType.threeOneColumnUmbBlockGrid;

	static FourColumnBlockGrid =
		FourColumnUmbBlockGridElementModelContentType.fourColumnUmbBlockGrid;
	static CustomizableLink =
		CustomizableLinkUmbBlockPartialElementModelContentType.customizableLinkUmbBlockPartial;
}
